import { useEffect } from 'react';
interface SeoProps {
  title: string;
  description: string;
}
export function Seo({
  title,
  description
}: SeoProps) {
  useEffect(() => {
    document.title = `${title} | HPP Training Las Vegas`;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, [title, description]);
  return null;
}